import sharedConstants from "@lib/shared_constants";

import type { ComponentStoreData, ContentOptimizationContextStruct } from "./types";

export const excludedLinkPrefixMaxCount = sharedConstants.CONTENT_OPTIMIZATION_EXCLUDED_LINK_PREFIXES.MAX_COUNT;
export const excludedLinkPrefixMaxLength = sharedConstants.CONTENT_OPTIMIZATION_EXCLUDED_LINK_PREFIXES.MAX_LENGTH;

// convenient to avoid an extra import sometimes
export const minimumComponentValuesForActive = sharedConstants.CONTENT_OPTIMIZATION.MIN_VARIANTS_NEEDED;
export const maximumComponentValuesForActive = sharedConstants.CONTENT_OPTIMIZATION.MAX_VARIANTS_ALLOWED;
export const minimumRecommendedCombinationCount = sharedConstants.CONTENT_OPTIMIZATION.MIN_RECOMMENDED_COMBINATIONS;

export const minAudienceForOptimization = sharedConstants.CONTENT_OPTIMIZATION.MIN_AUDIENCE_FOR_OPTIMIZATION;
export const minPerDispatchVolume = sharedConstants.CONTENT_OPTIMIZATION.MIN_PER_DISPATCH_VOLUME;
export const minLifetimeRemaining = sharedConstants.CONTENT_OPTIMIZATION.MIN_LIFETIME_REMAINING;

export const maxAllowedActiveCoStepsFree = sharedConstants.CONTENT_OPTIMIZATION.MAX_ALLOWED_CO_STEPS_FREE;

export const defaultComponentStoreData: ComponentStoreData = {
  components: {},
};

export const defaultContentOptimizationContextStruct: ContentOptimizationContextStruct = {
  componentStoreData: defaultComponentStoreData,
  selectedComponentOverrides: {},
  setSelectedComponentOverrides: () => {},
  componentSuggestionsData: {},
  setComponentSuggestionsData: () => {},
  generationInstructions: "",
  setGenerationInstructions: () => {},
  isContentOptimization: false,
  isDraft: true,
  isComponentStoreReadOnly: false,
  activeComponentTab: null,
  setActiveComponentTab: () => {},
  composerSection: undefined,
  setComposerSection: () => {},
  addComponentFromComponentTag: () => {},
  deleteComponentModalState: {
    isOpen: false,
    componentName: null,
  },
  openDeleteComponentModal: () => {},
  closeDeleteComponentModal: () => {},
  confirmDeleteComponent: () => {},
  isComponentLimitModalOpen: false,
  setIsComponentLimitModalOpen: () => {},
  allowedChannels: [],
  emailLinks: [],
  emailSenderDisplayName: null,
  emailSubject: null,
  emailPreheader: null,
  pushTitle: null,
  pushMessage: null,
  pushImagePlatforms: [],
  rcsImageEligible: false,
  variantActivationWarningDismissed: false,
  dismissVariantActivationWarning: () => {},
};
